import type { IntlShape } from "react-intl";
import type { StatusPillLevel } from "../components/ui/StatusPill";

/** Mapeia o status bruto de uma live para o nível visual do StatusPill (cor). */
export function getLiveStatusLevel(status?: string | null): StatusPillLevel {
  const s = String(status ?? "").trim().toUpperCase();
  if (s === "STARTED") return "success";
  if (s === "WAIT_START") return "warning";
  if (s === "FAILED" || s === "CANCELED" || s === "CANCELLED") return "error";
  return "neutral";
}

export function isUpcomingLiveStatus(status?: string | null): boolean {
  const s = String(status ?? "").trim().toUpperCase();
  return s === "STARTED" || s === "WAIT_START";
}

export function formatLiveStatus(intl: IntlShape, status?: string | null): string {
  const s = String(status ?? "").trim().toUpperCase();
  if (!s) return "-";
  if (s === "WAIT_START") return intl.formatMessage({ id: "liveStatus.waitStart" });
  if (s === "STARTED") return intl.formatMessage({ id: "liveStatus.started" });
  if (s === "FINISHED") return intl.formatMessage({ id: "liveStatus.finished" });
  if (s === "FAILED") return intl.formatMessage({ id: "liveStatus.failed" });
  if (s === "CANCELED" || s === "CANCELLED") return intl.formatMessage({ id: "liveStatus.canceled" });
  return s;
}
